import React from "react";

const SnakeLadderTournament = () => {
    return <div>SnakeLadderTournament</div>;
};

export default SnakeLadderTournament;
